<template>
    
</template>

<script>

export default{
  name: 'Blank',
    mixins: [],
    components: { 
        
    },
    data: function () {
      return {
      }
    },
    computed: {
        
    },
    watch:{
      
    },
    mounted(){
       
    },
    methods:{
        
    }
  };
</script>

